module.exports = __webpack_public_path__ + "img/hero-investor-woman.5a2b9ce.png";